/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { IconSizeType } from 'common/constants';
import { UserIconEl } from 'common/widgets/user-icon';
import type { CellRenderContext, TableColumn, TableRow } from 'common/components/table/types';
import { FieldWithMatches } from 'common/components/table/cell-mixins';
import { getEntityCreatorDisplayName } from 'common/report/stores/user-details';

/**
 * NOTE: this cell mixin assumes a userDetailsStore subscription somehwere in the consumer app.
 */
function CellTypeUser(_ref: {
  item: TableRow;
  context: CellRenderContext;
}) {
  let {
    item,
    context
  }: {
    item: TableRow;
    context: CellRenderContext;
  } = _ref;
  return <>
      <UserIconEl attrs={{
      id: item.user_id || item.userId || Number(item.id),
      name: context.label,
      'disable-tooltip': true,
      'disable-sidebar': !!item.disableUserSidebar,
      size: IconSizeType.Small,
      email: item.userEmail
    }} data-sentry-element="UserIconEl" data-sentry-source-file="user.tsx" />
      <div sel='.mp-table-cell-type-user-label'>
        <FieldWithMatches item={item} context={context} data-sentry-element="FieldWithMatches" data-sentry-source-file="user.tsx" />
      </div>
    </>;
}
export const userCellRenderer: TableColumn[`cellRenderer`] = (row, context) => {
  return <CellTypeUser item={row} context={context} data-sentry-element="CellTypeUser" data-sentry-component="userCellRenderer" data-sentry-source-file="user.tsx" />;
};
export const userCellLabelTransform: TableColumn[`labelTransform`] = (row, label) => {
  return getEntityCreatorDisplayName(row.userEmail, row[label]);
};
export const userColumnProps: Partial<TableColumn> = {
  cellRenderer: userCellRenderer,
  labelTransform: userCellLabelTransform,
  type: "user"
};